import { SVGFC } from '@repo/toolkit/types'

const UserThreeIcon: SVGFC = ({ color = 'white', ...props }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.5307 12.4916L14.9395 12.3313L14.9009 12.9426C14.8341 14.0001 14.365 14.9015 13.671 15.8285L13.5545 14.8027L14.0778 13.7794L14.0778 13.7794C14.1691 13.6007 14.2126 13.4014 14.2033 13.2006C14.1941 12.9999 14.1325 12.8055 14.0254 12.636C13.9183 12.4665 13.7695 12.3279 13.5941 12.2323C13.4188 12.1367 13.2221 12.0869 13.0228 12.0869H13.0227H10.9773C10.7779 12.0869 10.5813 12.1367 10.4059 12.2323C10.2305 12.3279 10.0817 12.4665 9.97462 12.6359C9.86746 12.8055 9.80588 12.9998 9.79662 13.2006C9.78737 13.4014 9.83082 13.6007 9.92218 13.7794L9.9222 13.7794L10.4455 14.8027L10.329 15.8285C9.63497 14.9015 9.16594 14.0001 9.09911 12.9426L9.06048 12.3313L8.4693 12.4916C7.12168 12.8568 5.99012 13.4986 5.19958 14.5191C4.40853 15.5402 4 16.8876 4 18.5868V21.2534C4 21.5665 4.12731 21.8645 4.35014 22.0823C4.5726 22.2999 4.87196 22.4201 5.18182 22.4201H18.8182C19.128 22.4201 19.4274 22.2999 19.6499 22.0823C19.8727 21.8645 20 21.5665 20 21.2534V18.5868C20 16.8876 19.5915 15.5403 18.8004 14.5191C18.0099 13.4986 16.8783 12.8568 15.5307 12.4916Z"
        stroke={color}
      />
      <path
        d="M11.9989 11.7531C13.1511 11.7531 14.1357 11.0592 14.8096 10.1603C15.4864 9.2574 15.908 8.07747 15.908 6.94885C15.908 5.79796 15.4678 4.89406 14.7259 4.28783C13.9973 3.69249 13.023 3.41992 11.9989 3.41992C10.9749 3.41992 10.0006 3.69249 9.27197 4.28783C8.53008 4.89406 8.08984 5.79796 8.08984 6.94885C8.08984 8.07747 8.51144 9.2574 9.18828 10.1603C9.86219 11.0592 10.8467 11.7531 11.9989 11.7531Z"
        stroke={color}
      />
    </svg>
  )
}

export default UserThreeIcon
